import { BlogSection } from '@/types/blog';

export const intro: BlogSection = {
  id: 'intro',
  title: '',
  content: `
    <p>
      Kennst du das Gefühl, wenn ein einzelnes Lied im richtigen Moment deine Stimmung verändert? Ob du dir dessen bewusst bist oder nicht: Musik hat die Kraft, dein Gehirn in Sekundenbruchteilen zu verändern und Klarheit für deine Entscheidungen zu schaffen.
    </p>
  `
};
